import React, { useMemo, useState } from "react";
import { Button, Group, Modal, NumberInput, Select, Stack, TextInput } from "@mantine/core";
import {
  DeviceCategoryEnum,
  DEVICES_TYPES_SETTINGS,
} from "@multiconsult-group/multiplacer-core";
import { useAppDispatch } from "../../app/hooks";
import { addGenericDeviceToSelectedRoomThunk } from "../../DesignTab/devices/deviceThunks";

type Props = {
  onClose: () => void;
  initialDeviceCategory?: DeviceCategoryEnum;
};

const GENERIC_DEVICE_CATEGORIES = [
  DeviceCategoryEnum.SUPPLY_AIR_DEVICE,
  DeviceCategoryEnum.RETURN_AIR_DEVICE,
  DeviceCategoryEnum.LIGHT_DEVICE,
  DeviceCategoryEnum.SENSOR_DEVICE,
  DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE,
  DeviceCategoryEnum.CHILLER,
] as const;

export const GenericDeviceModal: React.FC<Props> = ({ onClose, initialDeviceCategory }) => {
  const dispatch = useAppDispatch();
  const [deviceCategory, setDeviceCategory] = useState<DeviceCategoryEnum>(
    initialDeviceCategory ?? DeviceCategoryEnum.SUPPLY_AIR_DEVICE
  );
  const [widthTiles, setWidthTiles] = useState(1);
  const [lengthTiles, setLengthTiles] = useState(1);
  const [description, setDescription] = useState("");

  const categoryOptions = useMemo(
    () =>
      GENERIC_DEVICE_CATEGORIES.map((category) => ({
        value: category,
        label: DEVICES_TYPES_SETTINGS[category]?.label ?? category,
      })),
    []
  );

  const handleAdd = () => {
    const width = Math.max(1, Math.round(widthTiles));
    const length = Math.max(1, Math.round(lengthTiles));
    dispatch(
      addGenericDeviceToSelectedRoomThunk({
        deviceCategory,
        tileSize: [width, length],
        description,
      })
    );
    onClose();
  };

  return (
    <Modal opened onClose={onClose} title="Legg til generisk komponent" centered>
      <Stack gap="sm">
        <Select
          label="Type"
          data={categoryOptions}
          value={deviceCategory}
          onChange={(value) => {
            if (value) setDeviceCategory(value as DeviceCategoryEnum);
          }}
        />
        <Group grow align="flex-start">
          <NumberInput
            label="Bredde i plater"
            min={1}
            max={20}
            step={1}
            allowDecimal={false}
            value={widthTiles}
            onChange={(value) => setWidthTiles(Number(value) || 1)}
          />
          <NumberInput
            label="Lengde i plater"
            min={1}
            max={20}
            step={1}
            allowDecimal={false}
            value={lengthTiles}
            onChange={(value) => setLengthTiles(Number(value) || 1)}
          />
        </Group>
        <TextInput
          label="Navn"
          placeholder={`Generisk ${DEVICES_TYPES_SETTINGS[deviceCategory]?.label?.toLowerCase() ?? "komponent"} ${widthTiles}x${lengthTiles}`}
          value={description}
          onChange={(event) => setDescription(event.currentTarget.value)}
        />
        <Group justify="flex-end" mt="sm">
          <Button variant="neutral" onClick={onClose}>
            Avbryt
          </Button>
          <Button onClick={handleAdd}>Legg til</Button>
        </Group>
      </Stack>
    </Modal>
  );
};
